export function XeroSupportClearContactIfNotFoundCtrl ($scope, $uibModalInstance, workshopAPI, contact) {

  $scope.contact = contact ? contact : {};

}